export default "__VITE_ASSET__DKp5Itgl__"